/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import Wrapper from "../layout/Wrapper";
import BannerComp from "../components/BannerComp/BannerComp";
import assests from "../ui/assests";
import WhyComp from "../components/CareerSecComp/WhyComp";
import CareerOpeningsComp from "../components/CareerSecComp/CareerOpeningsComp";
import VideoSec from "../components/CareerSecComp/VideoSec";
import DesignFutureSec from "../components/HomeSecComp/DesignFutureSec";
import TeamsCollaborationSec from "../components/CareerSecComp/TeamsCollaborationSec";

export default function Career() {
  return (
    <Wrapper>
      <BannerComp
        image={assests.carrerBg}
        title="Build the Future of the Web with Us"
        description="We’re a creative web design and development company offering SEO, digital marketing, and complete web solutions—backed by a passionate team delivering excellence to every client."
      />
      <WhyComp />
      <CareerOpeningsComp />
      <TeamsCollaborationSec/>
      <VideoSec />
      <DesignFutureSec />
    </Wrapper>
  );
}
